import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('medicare_advantage_benefits_set',
  '/medicare_advantage_benefits_sets',
  'benefits_set')
const reducer = generator.generate()

export default reducer
